import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: "Dispatcher's Daily Gaps",
	url: '/managers/time_tracking/daily_gaps',
	icon: 'dashboard'
}];

export default class DispatcherDailyGaps extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.DispatcherDailyGaps history={history} />
					</div>
				</div>
			</div>
		)
	}
}
